<div id="body"
     class="flex-box">
    <div class="page-content">
        <div style="position:relative;">
            <div class="page-box-1 height-300">
                <div>
                    <h1 class="heading-1">Logging In...</h1>
                    <app-error *ngIf="error"
                               [error]="error"
                               [errorMessage]="errorMessage">
                    </app-error>
                </div>
            </div>
        </div>
    </div>
</div>
